import React from 'react';
import Two from '../layouts/two';
import Title from '../partials/title';
import FAQ from './partials/faq';
import _ from 'lodash';

class FAQS extends React.Component {
    state = { activeTab: 1, qas: null }
    componentWillMount() {
        const { qas, qasActions } = this.props;
        if (!qas) this.setState({ microTransac: true }, () => {
            qasActions && qasActions.fetch();
        });
        else this.setState({ qas });
    }
    componentWillReceiveProps = nextProps => {
        const { qas } = nextProps;
        this.setState({ qas, microTransac: false });
    }
    onTab = (activeTab) => this.setState({ activeTab });
    render() {
        const { activeTab, qas } = this.state;
        return <Two nbs="faqs" title="FAQ" bi="/images/backgrounds/faqs.jpg">
            <section>
                <div className="w3-white" id="tournament">
                    <div className="w3-container w3-content">
                        <Title text="Do Not Entertain Doubts" className="black margin-top-double" />
                        <div className="d-flex flex-row margin-top-double hind">
                            <button onClick={() => this.onTab(1)} className={`w-100 btn bg-${activeTab === 1 ? 'red' : 'black'} p-2 white`}>About 3v3</button>
                            <button onClick={() => this.onTab(2)} className={`w-100 btn bg-${activeTab === 2 ? 'red' : 'black'} p-2 white`}>Tournaments</button>
                            <button onClick={() => this.onTab(3)} className={`w-100 btn bg-${activeTab === 3 ? 'red' : 'black'} p-2 white`}>Registration</button>
                        </div>
                        <hr />
                        {qas && _.chain(qas).filter(qa => parseInt(qa.IdCategory, 10) === activeTab).value().map((qa, index) => <FAQ qa={qa} key={index} />)}
                    </div>

                </div>
            </section>
        </Two>
    }
}

export default FAQS;



// WEBPACK FOOTER //
// ./src/components/faqs/index.js